import { useThemeStore } from '@shared/store';
import { formateThemeData } from './utils';
import { defaultSkinThemes } from './mock-theme';
import type { ThemeCodeStyle } from './types';

type themeStyle = ThemeCodeStyle | null;

export function useThemeConfig(): themeStyle {
  let themeConfig = formateThemeData(defaultSkinThemes);
  const stationThemeConfig = useThemeStore().stationThemeConfig;

  try {
    if (stationThemeConfig.length) {
      themeConfig = formateThemeData(stationThemeConfig);
    }
  } catch (err) {
    console.log(err);
  }

  return themeConfig;
}
